import { z } from 'zod';

import { getTranslation } from '../../../../utils/get-translation.util';

const VAULT_NAME_MAX_LENGTH = 255;

// The Vault's own rule for a name: letters, digits, spaces, `_`, `-` and `.`, neither starting nor
// ending with one of those three. The same rule the Vault page applies to a rename.
const VAULT_NAME_PATTERN = /^(?![_\-.])[a-zA-Z0-9 _.-]+(?<![_\-.])$/;

export const renameVaultFileSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, { message: getTranslation('REQUIRED') })
    .max(VAULT_NAME_MAX_LENGTH, {
      message: getTranslation('MAXIMUM_CHARACTERS', { count: VAULT_NAME_MAX_LENGTH }),
    })
    .regex(VAULT_NAME_PATTERN, { message: getTranslation('INVALID_NAME') }),
});

export type RenameVaultFileForm = z.infer<typeof renameVaultFileSchema>;
